import { Block } from 'slate';
import insertTextNodes from './insertTextNodes';

export default (incomingBlock, editor) => {
  const newBlock = Block.create({
    type: 'paragraph',
    nodes: incomingBlock.nodes,
    data: incomingBlock.data,
  });

  if (!editor.value.focusBlock.text) insertTextNodes(incomingBlock, editor);
  else editor.insertBlock(newBlock);

  // get focus block key
  const focusBlockKey = editor.value.focusBlock.key;

  // wrap new block in list item
  editor.wrapBlockByKey(focusBlockKey, 'list_item');

  // get parent of focus block
  const focusBlockParent = editor.value.document.getParent(
    editor.value.focusBlock.key,
  );

  // wrap focus block in unordered list
  editor.wrapBlockByKey(focusBlockParent.key, 'unordered_list');
};
